export const SET_SUPERVISOR = 'SET_SUPERVISOR';

export const setSupervisor = (value: boolean) => ({
  type: SET_SUPERVISOR,
  payload: value,
});
